import { ReactNode } from 'react';
import styles from './styles/InfoBlock.module.scss';
import SectionHeader, { SectionHeaderSize } from './SectionHeader';
import Info from 'icons/Info';

export default function InfoBlock({ title, children, footer }: { title: string; children: ReactNode; footer?: ReactNode }) {
  return (
    <div className={styles.Block}>
      <SectionHeader size={SectionHeaderSize.SMALL}>
        <Info height={16.5} width={16.5} />
        &nbsp;&nbsp;
        {title}
      </SectionHeader>
      <div className={styles.Content}>{children}</div>
      {footer && <div className={styles.Footer}>{footer}</div>}
    </div>
  );
}
